import React, { useState } from 'react';
import OrderInfoBlockMobile from './OrderInfoBlockMobile';
import { BASE_URL } from '../../../shared/constants';
import OrderItemsDesktop from './OrderItemsDesktop';
import OrderDeliveryDesktop from './OrderDeliveryDesktop';
import OrderInfoBlockDesktop from './OrderInfoBlockDesktop';
import { Link } from 'react-router-dom';

const OrderConfirmationDesktop = ({ order, paymentSettings }) => {
  const [modalImage, setModalImage] = useState('');

  if (!order) return null;

  return (
    <div className='py-4'>

      {/* ===== TOP MESSAGE ===== */}
      <div className='text-center mb-4'>
        <h4 className='font-weight-bold mb-2'>
          Дякуємо за замовлення!
        </h4>
        <div className='text-muted'>
          Ваше замовлення успішно прийняте
        </div>
      </div>


      <OrderInfoBlockDesktop
        doNotCall={order.doNotCall}
        paymentType={order.paymentType}
        paymentStatus={order.paymentStatus}
        discountedPrice={order.discountedPrice}
        orderId={order.orderId}
        paymentSettings={paymentSettings}
        items={order.items}
      />

      {/* ===== ITEMS + DELIVERY ===== */}
      <div className='row'>
        <div className='col-7'>
          <OrderItemsDesktop
            order={order}
            items={order.items}
            totalPrice={order.totalPrice}
            discountedPrice={order.discountedPrice}
            setModalImage={setModalImage}
          />
        </div>

        <div className='col-5'>
          <OrderDeliveryDesktop delivery={order.delivery} />
          
          {order.userComment && (
            <div className='card mt-3'>
              <h5 className='card-header font-weight-bold'>
                💬 Ваш коментар до замовлення
              </h5>
              <div className='card-body'>
                <div style={{ whiteSpace: 'pre-line' }}>{order.userComment}</div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className='pt-3 text-center text-muted mb-3'>
        <p className='mb-0'>
          З будь-яких питань -{' '}
          <a
            href='https://t.me/waaaghShopAdmin'
            target='_blank'
            rel='noopener noreferrer'
            className='font-weight-bold'
          >
            звертайтеся до нас у Telegram
          </a>{' '}
          або телефонуйте за номером, вказаним у шапці сайту
        </p>
      </div>

      <div className='pt-3'>
        <Link to='/user/personal-cabinet' className='btn btn-dark mr-2'>
          Переглянути мої замовлення
        </Link>
        <Link to='/' className='btn btn-success'>
          На головну
        </Link>
      </div>

      <div
        className='modal fade'
        id='imageModalDesktop'
        tabIndex='-1'
        role='dialog'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered modal-lg' role='document'>
          <div className='modal-content bg-transparent border-0'>
            <div className='modal-body p-0 text-center'>
              <img
                src={`${BASE_URL}/api/v1/product/image/${modalImage}`}
                alt='Product'
                className='img-fluid'
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default OrderConfirmationDesktop;
